import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/lib/i18n';
import { usePlan } from '@/hooks/use-plan';
import { Button } from '@/components/ui/button';
import { Sparkles, ArrowRight, Lock } from 'lucide-react';

export function UpgradeBanner({ feature, requiredPlan = 'basis' }) {
  const { language } = useLanguage();
  const nav = useNavigate();
  const { plan } = usePlan();
  const de = language === 'de';

  if (plan === 'premium' || (requiredPlan === 'basis' && (plan === 'basis' || plan === 'premium'))) return null;

  return (
    <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200/60 rounded-2xl p-5 flex items-center gap-4" data-testid="upgrade-banner">
      <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center shrink-0">
        <Lock size={20} className="text-amber-600" />
      </div>
      <div className="flex-1">
        <p className="font-display text-sm font-medium text-foreground">
          {de ? `${feature} – ${requiredPlan === 'premium' ? 'Premium' : 'Basis'} Feature` : `${feature} – ${requiredPlan === 'premium' ? 'Premium' : 'Basis'} Feature`}
        </p>
        <p className="font-body text-xs text-foreground/50 mt-0.5">
          {de ? `Upgrade auf ${requiredPlan === 'premium' ? 'Premium' : 'Basis'} um diese Funktion freizuschalten` : `Upgrade to ${requiredPlan === 'premium' ? 'Premium' : 'Basis'} to unlock this feature`}
        </p>
      </div>
      <Button onClick={() => nav('/pricing')} className="rounded-full bg-terracotta hover:bg-terracotta-dark text-white px-4 py-2 text-sm shrink-0" data-testid="upgrade-btn">
        <Sparkles size={14} className="mr-1" /> Upgrade
      </Button>
    </div>
  );
}

export function PlanBadge() {
  const { plan } = usePlan();
  if (plan === 'free') return null;
  const colors = plan === 'premium' ? 'bg-amber-100 text-amber-700' : 'bg-sage/10 text-sage';
  return (
    <span className={`px-2 py-0.5 rounded-full text-[10px] font-body font-semibold uppercase ${colors}`} data-testid="plan-badge">
      {plan}
    </span>
  );
}
